export default __webpack_public_path__ + "static/media/icon-user.c8fe9741.svg";